export default __webpack_public_path__ + "static/media/fish necklace yellow.95d68e3a.png";